import { type_GM_STATE } from "./types"

declare var GM_STATE: type_GM_STATE

/**
 * @returns { {
*    'Content-Type': 'application/json',
*    Accept: 'application/json',
*    'X-Shopify-Storefront-Access-Token': string
* } }
*/
function getGraphQlHeaders () {
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Shopify-Storefront-Access-Token': GM_STATE.apis.storefrontAccessToken
  }
}

/**
* Returns graphql request with no callback
* @param { {
*  query: string
*  variables?: unknown
* } } param0
* @returns { fetch }
*/
type ExecuteGraphQlQuery = {
  query: string
  variables: any
}

export const executeGraphQlQuery = ({ query, variables }: ExecuteGraphQlQuery) => {
  const url = GM_STATE.apis.graphQlEndpoint
  // remove line breaks and double space for legibility
  const cleanQuery = query.replace(/\n/g, ' ').replace(/ {2}/g, '')
  const config = {
    method: 'post',
    headers: getGraphQlHeaders(),
    body: JSON.stringify({
      query: cleanQuery,
      // only add variables if they actually exist
      ...(variables ? { variables } : {})
    })
  }
  return fetch(url, config)
}

type ProductCurrencyDataProps = {
  country: string
  productIds: string[]
}

export const getProductCurrencyData = async ({productIds, country}: ProductCurrencyDataProps) => {
  const query = `
    query ($ids: [ID!]!, $country: CountryCode!) 
    @inContext(country: $country) {
      nodes(ids: $ids) {
          ... on Product {
            id
            variants(first: 25) {
              nodes {
                price {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
  `;

  const variables = {
    ids: productIds, 
    country: country?.toUpperCase()
  }

  const response = await executeGraphQlQuery({ query, variables })
    .then(res => res.json())
    .then(data => {
      if (data.errors) {
        throw data
      }
      return data.data
    })
    .catch(error => {
      console.warn('error', error)
      return null
    })

  // have results/no results so we can build our suggestions HTML
  return response?.nodes ? response : null
}